import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import "moment/locale/pt-br";
import styles from './styles.module.scss';
import { getResultados } from '../../../services/api-auto';
import { useDispatch } from "react-redux";
import { 
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction
} from '../../../store/actions/snackbarActions.js';
import ModalLoading from '../../../components/ModalLoading';
import ParticipanteQuizCard from '../../../components/ParticipanteQuizCard';

const dataInit = {
    totalRespostas: 0,
    totalAcertos: 0,
    totalErros: 0,
    totalPontos: 0,
    participantes: [{
        nomeParticipante : "",
        distribuidor: "",
        acertosTotais: 0,
        pontosGanhos: 0
    }]
}


const ResultadosQuiz = () => {
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const history = useHistory();
    const [data, setData] = useState(dataInit);
    const [modalLoading, setModalLoading] = useState(false);
    const [quizId, setQuizId] = useState();

    

    const getQuizIf = async (id) => {

        if(id) {
            setModalLoading(true);
            try{
                const info = await getResultados(id);
                setData(info.data);

            } catch(e){
                showMsgW('Não foi possível carregar os dados');
            }
            setModalLoading(false);
        }
    }

    useEffect( () => {
        const id = new URLSearchParams(history.location.search).get("QuizId");
        setQuizId(id);
        getQuizIf(id);
    },[])

    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    Resultados do quiz
                    <button className={styles.backButton} onClick={() => {history.goBack()}}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                </div>

                <div className={styles.blueBackground}>
                    <div className={styles.content}>
                        <div className={styles.card} style={{padding: '16px 16px 16px 16px'}}>
                            <div className={styles.totais}>
                                <div>Total de respostas</div>
                                <div className={styles.black}>{data.totalRespostas}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.blueBackground}>
                    <div className={styles.content}>
                        <div className={styles.card} style={{padding: '16px 16px 16px 16px'}}>
                            <div className={styles.totais}>
                                <div>Total de acertos</div>
                                <div className={styles.green}>{data.totalAcertos}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.blueBackground}>
                    <div className={styles.content}>
                        <div className={styles.card} style={{padding: '16px 16px 16px 16px'}}>
                            <div className={styles.totais}>
                                <div>Total de erros</div>
                                <div className={styles.red}>{data.totalErros}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.content}>
                    <div className={styles.card} style={{padding: '16px 16px 6px 16px'}}>
                        <div className={styles.subtitle}>
                            Participantes
                        </div>
                        { data.participantes.map((p) => (
                            <>
                                <ParticipanteQuizCard participantequiz={p}/>
                            </>
                        ))}
                    </div>
                </div>

                <div className={styles.content}>
                    <div className={styles.card} style={{border: '1px solid #CFDCDF'}}>
                        <div className={styles.totais}>
                            <div>Total de pontos</div>
                            <div className={styles.green}>{data.totalPontos}</div>
                        </div>
                    </div>
                </div>
                
            </div>
            <ModalLoading
                open={modalLoading} 
                size="lg"
            />

        </>
    );
}

export default ResultadosQuiz;